module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "TITLE"
  }, [_vm._v("The Story Luke Tells")]), _vm._v(" "), _c('p', {
    staticClass: "SUBTITLE"
  }, [_vm._v("Luke’s Unique Witness to the Gospel")]), _vm._v(" "), _c('p', {
    staticClass: "AUTHOR"
  }, [_vm._v("Justo L. González")]), _vm._v(" "), _c('p', {
    staticClass: "COMPANY"
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("William B. Eerdmans Publishing Company"), _c('br')]), _vm._v("Grand Rapids, Michigan / Cambridge, U.K.")]), _vm._v(" "), _c('p', {
    staticClass: "COPYRIGHT"
  }, [_vm._v("© 2015 Justo L. González"), _c('br'), _vm._v("All rights reserved"), _c('br'), _c('br'), _c('span', {
    staticClass: "sc"
  }, [_vm._v("Wm. B. Eerdmans Publishing Co."), _c('br')]), _vm._v("2140 Oak Industrial Drive "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("n.e.")]), _vm._v(", Grand Rapids, Michigan 49505 /"), _c('br'), _c('span', {
    staticClass: "sc"
  }, [_vm._v("p.o.")]), _vm._v(" Box 163, Cambridge "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("cb3 9pu")]), _vm._v(" U.K."), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.eerdmans.com",
      "target": "_blank"
    }
  }, [_vm._v("www.eerdmans.com")]), _c('br'), _c('br'), _vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "LIBRARY"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "CIP"
  }, [_vm._v("González, Justo L."), _c('br'), _vm._v("The story Luke tells: Luke’s unique witness to the gospel /"), _c('br'), _vm._v("Justo L. González."), _c('br'), _vm._v("pages   cm"), _c('br'), _vm._v("ISBN 978-0-8028-7200-5 (pbk.: alk. paper)"), _c('br'), _vm._v("eISBN 978-1-4674-4297-8 (ePub)"), _c('br'), _vm._v("eISBN 978-1-4674-4257-2 (Kindle)"), _c('br'), _vm._v("1. Bible. Luke — Criticism, interpretation, etc."), _c('br'), _vm._v("2. Bible. Acts — Criticism, interpretation, etc. I. Title."), _c('br'), _c('br'), _vm._v("BS2589.G66 2015"), _c('br'), _vm._v("226.4´06 — dc23"), _c('br'), _vm._v("                 2014033462")]), _vm._v(" "), _c('p', {
    staticClass: "NRSV"
  }, [_vm._v("Unless otherwise noted, the Scripture quotations in this publication are from the New Revised Standard Version Bible, copyright © 1989 by the Division of Christian Education of the National Council of Churches of Christ in the U.S.A., and used by permission.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c88b066","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gonzalez_The_Story_Luke_Tells_text_CC.vue
// module id = 57
// module chunks = 0